import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCompareContext } from '../../../Context';
import { useCreditCardCompareColumnContext } from '../../ColumnContext';
export function Observer(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    setShowStickyHeader
  } = useCompareContext();
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0,
      triggerOnce: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    inView,
    entry
  } = useInView(t1);
  let t2;
  if ($[1] !== entry || $[2] !== inView || $[3] !== index || $[4] !== setShowStickyHeader) {
    t2 = () => {
      if (inView && index === 0) {
        setShowStickyHeader(false);
      }
      if (!entry?.boundingClientRect) {
        return;
      }
      if (!inView && index == 0 && entry.boundingClientRect.top <= 0) {
        setShowStickyHeader(true);
      }
    };
    $[1] = entry;
    $[2] = inView;
    $[3] = index;
    $[4] = setShowStickyHeader;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== inView || $[7] !== index) {
    t3 = [inView, index];
    $[6] = inView;
    $[7] = index;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== children || $[10] !== ref) {
    t4 = <div ref={ref}>{children}</div>;
    $[9] = children;
    $[10] = ref;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}